import { useSelect } from 'admin';
import type { ApiEvidenceV1EvidenceTypesRetrieve200ResultsItem } from 'api';

import {
  AutocompleteField,
  type AutocompleteFieldProps,
  type AutocompleteOption,
} from '../AutocompleteField/AutocompleteField';

type Props = Omit<AutocompleteFieldProps<AutocompleteOption>, 'options'>;

export const EvidenceTypeSelector = ({ ...rest }: Props) => {
  const {
    options,
    query: { isFetching },
  } = useSelect<ApiEvidenceV1EvidenceTypesRetrieve200ResultsItem>({
    optionLabel: 'label',
    optionValue: 'value',
    pagination: {
      mode: 'off',
    },
    resource: '/evidence/v1/evidence-types',
  });

  return <AutocompleteField data-testid="evidence-type-selector" options={options} loading={isFetching} {...rest} />;
};
